import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Swiper from 'swiper';
import styled from 'styled-components';

import 'swiper/dist/css/swiper.min.css';
import { getReviews } from '../selectors';
import { fetchReviews } from '../actions';

class CmpReviewSwiper extends React.Component {
  componentDidMount() {
    this.initializeSwiper();
    this.props.fetchReviews();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reviews !== this.props.reviews) {
      this.swiper.destroy(true, true); // Destroy previous instance
      this.initializeSwiper(); // Reinitialize with updated reviews
    }
  }

  initializeSwiper() {
    const { reviews } = this.props;
    const middleIndex = Math.floor(reviews.length / 2); // Index of the middle review

    this.swiper = new Swiper('#swiper-reviews-elements', {
      direction: 'horizontal',
      slidesPerView: 2,
      roundLengths: true,
      spaceBetween: 50,
      initialSlide: middleIndex, // Set initial slide to the middle
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
    });
  }

  renderReview = (review) => (
    <div className="swiper-slide" key={review.photo}>
      <SwiperSlide>
        <h3 className="mb-4">{review.name}</h3>
        <p>{review.text}</p>
        <img src={review.photo} alt="фото автора"/>
      </SwiperSlide>
    </div>
  );

  render() {
    const { reviews } = this.props;

    return (
      <div id="swiper-reviews-elements">
        <div className="swiper-wrapper">
          {reviews.map(this.renderReview)}
        </div>
      </div>
    );
  }
}

CmpReviewSwiper.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  fetchReviews: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  reviews: getReviews(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchReviews: () => dispatch(fetchReviews()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CmpReviewSwiper);

const SwiperSlide = styled.div`
    padding: 2em;
    background: white;
    border-radius: .25rem;
    position: relative;
    width: 100%;

    h3 {
        text-align: center;
        color: #0d47a1;
    }

    p {
        font-size: 80%;
    }

    img {
        position: absolute;
        top: -30px;
        left: -30px;
    }
`;



// WEBPACK FOOTER //
// ./src/marathons/components/ReviewSwiper.jsx